<template>
  <el-dialog :title="title" :visible.sync="dialogShenHe" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border :height="tableHeight" :key="tableKey">
        <el-table-column type="index" prop="date" width="55" label="序号" fixed></el-table-column>
        <!-- <el-table-column width="180" label="操作" fixed>
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="submitClick(scope.row)" v-if="scope.row.isEditing">保存</el-button>
              <el-button v-if="!scope.row.isEditing" type="text" size="mini" @click="editClick(scope.row, scope.$index)">修改</el-button>
              <el-button type="text" size="mini" @click="delMaterial(scope.row,scope.$index)">删除</el-button>
              <el-button type="text" size="mini" @click="addRowFn(scope.row)" v-if="scope.$index === tableDataList.length - 1" >新增行</el-button>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="incomeExpenseType" width="75" label="收支类型">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing || scope.row.id">{{ scope.row.incomeExpenseType == 0 ? '收款' : '付款' }}</span>
              <el-select v-else v-model="scope.row.incomeExpenseType" placeholder="请选择" size="mini">
                <el-option label="收款" value="0" ></el-option>
                <el-option label="付款" value="1" ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="flowItemId" min-width="130" label="现金流项目">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.flowItemName }}</span>
              <el-cascader v-else v-model="scope.row.flowItemId" :key="scope.$index" style="width: 100%" ref="zuzhicascader" @change="zuzhiChange(scope.row,)" :options="BMlist" :props="{ expandTrigger:'hover', label:'name',value:'id',emitPath:false, checkStrictly: true}" placeholder="请选择" size="mini" ></el-cascader>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="itemName" width="90" label="项目名称">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.itemName }}</span>
              <el-input v-else v-model="scope.row.itemName" placeholder="请输入" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="paymentCycle" width="90" label="收付款周期">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.paymentCycle }}</span>
              <el-date-picker
                v-else
                v-model="scope.row.paymentCycle"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                size="mini"
                placeholder="请选择">
              </el-date-picker>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="invoiceStatus" width="80" label="开票情况">
          <template slot-scope="scope">
            <!-- 0：已开票 1：款到发货 2：预付款 -->
             <div>
               <span v-if="!scope.row.isEditing">{{ ['已开票' ,'款到发货','预付款'][scope.row.invoiceStatus] }}</span>
                <el-select v-else v-model="scope.row.invoiceStatus" placeholder="请选择" size="mini">
                <el-option label="已开票" value="0" ></el-option>
                <el-option label="款到发货" value="1" ></el-option>
                <el-option label="预付款" value="2" ></el-option>
              </el-select>
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="debtAmount" width="100" label="总欠款(万元)">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.debtAmount }}</span>
              <el-input v-else v-model="scope.row.debtAmount" placeholder="请输入" size="mini" v-number-input.float="4"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" width="100" label="供应商">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.supplierName }}</span>
              <el-input v-else v-model="scope.row.supplierName" placeholder="请输入" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" width="110">
            <template slot-scope="scope">
              <div>
                <span v-if="!scope.row.isEditing">{{ scope.row.cycleAmounts[item.valueKey] }}</span>
                <el-input v-else v-model="scope.row.cycleAmounts[item.valueKey]" @input="handleCycleAmount(scope.row, item, $event)" v-number-input.float="4" placeholder="请输入" size="mini"></el-input>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="paymentMethods" width="80" label="收支方式">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ ['现金' ,'承兑','现汇'][scope.row.paymentMethods] }}</span>
              <el-select v-else v-model="scope.row.paymentMethods" placeholder="请选择" size="mini">
                <el-option label="现金" value="0" ></el-option>
                <el-option label="承兑" value="1" ></el-option>
                <el-option label="现汇" value="2" ></el-option>
              </el-select>
             </div>
            <!-- 0：现金 1：承兑 2：现汇 -->
          </template>
        </el-table-column>
        <el-table-column prop="predictedAmount" width="140" label="预估收支合计(万元)">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.predictedAmount }}</span>
              <el-input v-else v-model="scope.row.predictedAmount" placeholder="请输入" size="mini" v-number-input.float="2"></el-input>
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" width="100" label="备注">
          <template slot-scope="scope">
            <div>
              <span v-if="!scope.row.isEditing">{{ scope.row.remark }}</span>
              <el-input v-else v-model="scope.row.remark" placeholder="请输入" size="mini"></el-input>
             </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-form label-width="80px" size="mini">
          <el-form-item label="审核备注:" >
            <el-input type="textarea" v-model="auditRemark" style="width:450px" rows="3"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="saveFn(1)">审核通过</el-button>
      <el-button type="primary" @click="saveFn(2)">审核驳回</el-button>
      <el-button @click="closeadd">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { findCashFlowItemList, detailList, saveMonthlyFundPlanDetail, delMonthlyFundPlanDetail, monthlyApprove, monthlyNotApprove } from '@/api/common-signature'
export default {
  name: 'monthPlanDialog',
  components: {},
  data () {
    return {
      tableDataList: [],
      rules: {},
      orgTreeData: [],
      BMlist: [],
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        yearMonthDate: ''
      },
      tableHeadList: [],
      detailForm: {
        pageNo: 1,
        pageSize: 200,
        monthlyPlanMasterId: '',
        cycleMasterId: '',
        incomeExpenseType: ''
      },
      tableHeight: 500,
      tableKey: 0,
      currentEditingRow: null, // 当前正在编辑的行
      isAnyRowEditing: false, // 是否有行正在编辑
      auditRemark: ''
    }
  },
  props: {
    title: {
      type: String
    },
    dialogShenHe: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
  },
  created () {
    this.findCashFlowItemList(true)
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  watch: {
    tableHeadList: {
      handler (newVal) {
        if (newVal && newVal.length > 0 && this.tableDataList.length > 0) {
        // 当表头变化时，确保每行数据都有对应的动态列值
          this.tableDataList.forEach(row => {
            if (!row.cycleAmounts) {
              row.cycleAmounts = {}
            }
            newVal.forEach(header => {
              if (row.cycleAmounts[header.valueKey] === undefined) {
                this.$set(row.cycleAmounts, header.valueKey, '')
              }
            })
          })
        }
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 600

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = 600 // 每行约40px
      }

      this.tableHeight = baseHeight
    },
    // 小星星
    addStar (obj) {
      if (obj.column.property == 'incomeExpenseType' || obj.column.property == 'flowItemId' || obj.column.property == 'itemName' || obj.column.property == 'supplierName' || obj.column.property == 'paymentMethods' || obj.column.property == 'paymentCycle') {
        return 'star'
      }
      if (obj.column.label && obj.column.label.includes('周')) {
        return 'star'
      }
    },
    detailList () {
      this.$set(this.detailForm, 'monthlyPlanMasterId', this.rowData.id)
      this.$set(this.detailForm, 'cycleMasterId', this.rowData.cycleMasterId)
      this.$set(this.detailForm, 'tenantFaction', this.rowData.tenantFaction)
      detailList(this.detailForm)
        .then(res => {
          console.log(res)
          this.tableHeadList = res.titleList || []

          if (res.pageInfo && res.pageInfo.list && res.pageInfo.list.length > 0) {
            // 处理数据，确保动态列的值正确绑定
            this.tableDataList = res.pageInfo.list.map(item => {
              // 确保 cycleAmounts 存在
              if (!item.cycleAmounts) {
                item.cycleAmounts = {}
              }

              // 将动态表头对应的值赋值给 cycleAmounts
              if (this.tableHeadList && this.tableHeadList.length > 0) {
                this.tableHeadList.forEach(header => {
                  // 如果返回的数据中有动态列的值，将其放入 cycleAmounts
                  if (item[header.valueKey] !== undefined) {
                    item.cycleAmounts[header.valueKey] = item[header.valueKey]
                  } else if (item.cycleAmounts[header.valueKey] === undefined) {
                    // 如果没有值，设置为空字符串
                    item.cycleAmounts[header.valueKey] = ''
                  }
                })
              }
              item.isEditing = false
              // 为每行数据计算预估收支合计
              // this.calculatePredictedAmount(item)
              return item
            })
          } else {
            // 如果没有数据，创建一个空行，并初始化动态列的值
            let objData = {
              incomeExpenseType: '',
              flowItemId: '',
              flowItemName: '',
              itemName: '',
              paymentCycle: '',
              invoiceStatus: '',
              debtAmount: '',
              supplierName: '',
              paymentMethods: '',
              predictedAmount: '',
              remark: '',
              cycleAmounts: {},
              isEditing: true
            }

            // 初始化动态表头对应的空值
            if (this.tableHeadList && this.tableHeadList.length > 0) {
              this.tableHeadList.forEach(header => {
                objData.cycleAmounts[header.valueKey] = ''
              })
            }
            this.tableDataList = [objData]
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.doLayout()
              }
            })
          }
          // console.log('处理后的表格数据:', this.tableDataList)
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    findCashFlowItemList (flag) {
      findCashFlowItemList().then((res) => {
        if (res.length > 0) {
          this.orgTreeData = res
          if (flag) {
            this.currentData = {
              title: res[0].name,
              parentId: res[0].id
            }
          }
          let jsonARR = JSON.parse(JSON.stringify(this.orgTreeData))
          this.BMlist = this.sAttributeList(jsonARR)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    zuzhiChange (row) {
      this.$nextTick(() => {
        const cascaderInstance = this.$refs.zuzhicascader // 假设你的el - cascader组件有ref="cascader"
        const checkedNodes = cascaderInstance.getCheckedNodes()[0]
        console.log(checkedNodes)
        this.$set(row, 'flowItemName', checkedNodes.data.name)
        this.$set(row, 'flowItemId', checkedNodes.data.id)
      })
    },
    handleCycleAmount (row, item, value) {
      // console.log(row, item, value)
      this.$set(row, item.valueKey, value)
      this.$set(row, item.key, item.id)
      this.$set(row.cycleAmounts, item.valueKey, value)
      // 自动计算预估收支合计
      this.calculatePredictedAmount(row)
    },
    // 计算预估收支合计
    calculatePredictedAmount (row) {
      if (!row.cycleAmounts) {
        row.predictedAmount = ''
        return
      }

      let total = 0
      let hasValue = false

      // 遍历所有周期列，累加值
      this.tableHeadList.forEach(item => {
        const value = row.cycleAmounts[item.valueKey]
        if (value && value !== '' && !isNaN(parseFloat(value))) {
          total += parseFloat(value)
          hasValue = true
        }
      })

      // 设置合计值，如果没有值则清空
      if (hasValue) {
        row.predictedAmount = parseFloat(total.toFixed(4))
      } else {
        row.predictedAmount = ''
      }
    },
    closeadd () {
      this.currentEditingRow = null
      this.isAnyRowEditing = false
      this.$emit('update:dialogShenHe', false)
    },
    addRowFn (row) {
      if (!this.validateRow(row, true)) {
        return
      }
      const hasTrue = this.tableDataList.some(item => item.isEditing === true)
      if (hasTrue) {
        this.$message.error('有未保存的数据，请先保存再新增行')
        return
      }
      // if (row.isEditing) {
      //   this.$message.error('请先保存当前行的编辑')
      //   return
      // }
      // 获取当前行的索引
      const currentIndex = this.tableDataList.findIndex(item => item === row)
      // 创建新的空行数据
      const newRow = {
        incomeExpenseType: '',
        flowItemId: '',
        flowItemName: '',
        itemName: '',
        paymentCycle: '',
        invoiceStatus: '',
        debtAmount: '',
        supplierName: '',
        paymentMethods: '',
        predictedAmount: '',
        remark: '',
        cycleAmounts: {},
        isEditing: true
      }

      // 初始化动态表头对应的空值
      if (this.tableHeadList && this.tableHeadList.length > 0) {
        this.tableHeadList.forEach(header => {
          newRow.cycleAmounts[header.valueKey] = ''
        })
      }

      // 在当前行的后面插入新行
      if (currentIndex !== -1) {
        this.tableDataList.splice(currentIndex + 1, 0, newRow)
      } else {
        // 如果没找到当前行，则在最后添加
        this.tableDataList.push(newRow)
      }

      // 重新渲染表格
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })

      // console.log('新增行成功:', newRow)
    },
    // 删除
    delMaterial (row, index) {
      if (!row.id) {
        this.tableDataList.splice(index, 1)
      } else {
        this.$confirm('是否执行删除操作？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          delMonthlyFundPlanDetail({
            id: row.id,
            monthlyPlanMasterId: this.rowData.id
          })
            .then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              if (this.tableDataList.length == 1) {
                this.closeadd()
                this.$parent.searchFn()
              }
              this.detailList()
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
      }
    },
    editClick (row, index) {
    // 检查是否有其他行正在编辑
      // if (this.isAnyRowEditing && this.currentEditingRow !== row) {
      //   this.$message.warning('请先完成当前行的编辑')
      //   return
      // }
      const hasTrue = this.tableDataList.some(item => item.isEditing === true)
      if (hasTrue) {
        this.$message.error('有未保存的数据，请先保存再修改')
        return
      }
      // 设置当前行为编辑状态
      row.isEditing = true
      this.currentEditingRow = row
      this.isAnyRowEditing = true
    },
    validateRow (row, rowAddFlag) {
    // 1. 收支类型
      if (!row.incomeExpenseType) {
        if (!rowAddFlag) this.$message.error('收支类型不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 2. 现金流项目
      if (!row.flowItemId) {
        if (!rowAddFlag) this.$message.error('现金流项目不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 3. 项目名称
      if (!row.itemName) {
        if (!rowAddFlag) this.$message.error('项目名称不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 4. 收付款周期
      if (!row.paymentCycle) {
        if (!rowAddFlag) this.$message.error('收付款周期不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 5. 供应商
      if (!row.supplierName) {
        if (!rowAddFlag) this.$message.error('供应商不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      // 6. 收支方式
      if (!row.paymentMethods) {
        if (!rowAddFlag) this.$message.error('收支方式不能为空')
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }

      // 7. 动态周期列校验
      const errors = []
      if (this.tableHeadList && this.tableHeadList.length > 0) {
        this.tableHeadList.forEach(item => {
          // 从 row.cycleAmounts 中获取值
          const value = row.cycleAmounts && row.cycleAmounts[item.valueKey]
          // 检查值是否为空（包括空字符串、null、undefined）
          if (value === '' || value === null || value === undefined) {
            errors.push(`${item.name}不能为空`)
            if (!rowAddFlag) errors.push(`${item.name}不能为空`)
            if (rowAddFlag) errors.push(`${item.name}请完整维护当前行数据`)
          }
        })
      }

      // 如果有错误，显示错误信息并停止执行
      if (errors.length > 0) {
        // 显示所有错误信息，每个错误单独一行
        const errorMsg = errors.join('\n')
        if (!rowAddFlag) this.$message.error(`以下字段不能为空：\n${errorMsg}`)
        if (rowAddFlag) this.$message.error('请完整维护当前行数据')
        return
      }
      return true
    },
    // 保存
    submitClick (row) {
      if (!this.validateRow(row)) {
        return
      }
      // 校验通过，执行保存
      this.saveMonthlyFundPlanDetail(row)
      // 所有校验通过，执行保存操作
      console.log('校验通过，开始保存', row)
    },
    saveMonthlyFundPlanDetail (row) {
      this.$set(row, 'monthlyPlanMasterId', this.rowData.id)
      this.$set(row, 'cycleMasterId', this.rowData.cycleMasterId)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      saveMonthlyFundPlanDetail(row)
        .then(res => {
          loading.close()
          console.log(res)
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          if (row.isEditing) {
            row.isEditing = false
            this.currentEditingRow = null
            this.isAnyRowEditing = false
          }
          this.detailList()
          // this.closeadd()
          this.$parent.searchFn()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    saveFn (flag) {
      if (flag == 2) {
        if (!this.auditRemark) {
          this.$message.error('请输入审核备注')
          return
        }
      }
      this.$confirm('是否执行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        let dataForm = {
          id: this.rowData.id,
          auditRemark: this.auditRemark
        }
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        if (flag == 1) {
          monthlyApprove(dataForm)
            .then(res => {
              loading.close()
              console.log(res)
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              // this.detailList()
              this.closeadd()
              this.$parent.searchFn()
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          monthlyNotApprove(dataForm)
            .then(res => {
              loading.close()
              console.log(res)
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              // this.detailList()
              this.closeadd()
              this.$parent.searchFn()
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
